import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "mb-10" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { style: { "font-size": "18px" } };
const _hoisted_5 = { class: "text-center text-md-end mt-10" };
import { ref, computed } from "vue";
import AppDialogContent from "../AppDialogContent.vue";
import gql from "fraql";
import { useQuery } from "@vue/apollo-composable";
import { useTranslation } from "i18next-vue";
import { camelCase, clone, cloneDeep } from "lodash-es";
import AppShowPersonName from "@AppShows/person/AppShowPersonName.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppChangeLogsViewer',
    props: {
        entityTypename: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const { t } = useTranslation();
        const dialog = ref(false);
        const entityId = ref(null);
        const logs = ref([]);
        const texts = computed(() => {
            switch (props.entityTypename) {
                case "HorseMedicalTreatment":
                    return {
                        title: t("horses:horseCarebook.horseMedicalTreatment.showRecordLog.modal.heading", "Show record log"),
                        hint: t("horses:horseCarebook.horseMedicalTreatment.showRecordLog.modal.hint", "Record log includes all changes of the horse medical treatment record to be able to checks the modifications done to the record after it has been created. "),
                        subheading: t("horses:horseCarebook.horseMedicalTreatment.showRecordLog.modal.record.subheading", "updated / created horse treatment record on")
                    };
                default:
                    return { title: null, hint: null, subheading: null };
            }
        });
        const idIsRequired = computed(() => ["HorseMedicalTreatment"].includes(props.entityTypename));
        const camelCaseEntity = computed(() => {
            return camelCase(props.entityTypename);
        });
        const { onResult, loading } = useQuery(gql `
    query ${camelCaseEntity.value}ChangeLogChanges($id: ID${idIsRequired.value ? "!" : ""}) {
      ${camelCaseEntity.value}(id: $id) {
        id
        changeLogChanges {
          version
          updatedAt
          updatedByPersonId
          changes {
            fieldName
            oldValue
            newValue
          }
        }
      }
    }
  `, () => ({ id: entityId.value }), () => ({ enabled: dialog.value }));
        onResult(({ loading, data }) => {
            if (loading)
                return;
            logs.value = clone(data[camelCaseEntity.value]?.changeLogChanges ?? []).sort((a, b) => (b.version > a.version ? 1 : -1));
        });
        function fieldNameLabel(fieldName) {
            fieldName = camelCase(fieldName);
            switch (props.entityTypename) {
                case "HorseMedicalTreatment":
                    return t(`horses:horseCarebook.horseMedicalTreatment.${fieldName}.label`, fieldName);
            }
        }
        const filteredLogs = computed(() => {
            return cloneDeep(logs.value).reduce((arr, log) => {
                log.changes = fieldFiltered(log.changes);
                if (log.changes.length > 0) {
                    arr.push(log);
                }
                return arr;
            }, []);
        });
        function fieldFiltered(changes) {
            let filtered = changes;
            switch (props.entityTypename) {
                case "HorseMedicalTreatment":
                    filtered = [
                        changes.find(x => x.fieldName === "startDate"),
                        changes.find(x => x.fieldName === "startTime"),
                        changes.find(x => x.fieldName === "diagnosis"),
                        changes.find(x => x.fieldName === "description"),
                        changes.find(x => x.fieldName === "productComposition"),
                        changes.find(x => x.fieldName === "dosage"),
                        changes.find(x => x.fieldName === "administration"),
                        changes.find(x => x.fieldName === "supplements"),
                        changes.find(x => x.fieldName === "veterinarian"),
                        changes.find(x => x.fieldName === "note")
                    ];
                    break;
            }
            return filtered.filter(Boolean);
        }
        function openChangeLogs(providedEntityId) {
            entityId.value = providedEntityId;
            dialog.value = true;
        }
        __expose({ openChangeLogs });
        return (_ctx, _cache) => {
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createBlock(AppDialogContent, {
                modelValue: dialog.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((dialog).value = $event)),
                "max-width": "1028px",
                "hide-actions": ""
            }, {
                header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(texts.value.title), 1)
                ]),
                default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(texts.value.hint), 1),
                    (_unref(loading))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_v_progress_linear, {
                                indeterminate: "",
                                active: ""
                            })
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLogs.value, (log, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: log.version + '-index-' + index,
                                    class: "elevation-2 pa-6 ma-4"
                                }, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode(AppShowPersonName, {
                                            person: log.updatedByPersonId
                                        }, null, 8, ["person"]),
                                        _createTextVNode(" " + _toDisplayString(texts.value.subheading) + " ", 1),
                                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                            activator: _withCtx(({ props: attrs }) => [
                                                _createElementVNode("span", _mergeProps({ ref_for: true }, attrs), _toDisplayString(_ctx.$dayjs(log.updatedAt).fromNow()), 17)
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$dayjs.date(log.updatedAt, "fullTime")), 1)
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                    _createVNode(_component_v_divider, { class: "my-3" }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.changes, (change, i) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: change.fieldName + i,
                                            class: "mb-1 pl-5"
                                        }, [
                                            _createElementVNode("b", null, _toDisplayString(fieldNameLabel(change.fieldName)), 1),
                                            _createTextVNode(" " + _toDisplayString(change.oldValue || "...") + " → " + _toDisplayString(change.newValue || "..."), 1)
                                        ]));
                                    }), 128))
                                ]));
                            }), 128))
                        ])),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_v_btn, {
                            "min-width": "295px",
                            outlined: "",
                            rounded: "",
                            onClick: _cache[0] || (_cache[0] = () => (dialog.value = false))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("common:button.close", "Close")), 1)
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
